var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66108 14C2.56972 13.9998 2.4794 13.9807 2.39586 13.9437C2.31231 13.9067 2.23737 13.8528 2.17579 13.7853C2.11311 13.7183 2.06527 13.6389 2.03543 13.5522C2.00558 13.4655 1.9944 13.3734 2.00262 13.2821L2.16394 11.5077L9.61642 4.05581L11.9454 6.38477L4.4949 13.836L2.721 13.9974C2.70108 13.9992 2.68108 14.0001 2.66108 14ZM12.4103 5.91911L10.082 3.59015L11.4786 2.19317C11.5397 2.13193 11.6123 2.08335 11.6923 2.05021C11.7722 2.01706 11.8579 2 11.9444 2C12.031 2 12.1166 2.01706 12.1966 2.05021C12.2765 2.08335 12.3491 2.13193 12.4103 2.19317L13.8069 3.59015C13.8681 3.65132 13.9167 3.72396 13.9498 3.80392C13.9829 3.88388 14 3.96959 14 4.05614C14 4.1427 13.9829 4.2284 13.9498 4.30836C13.9167 4.38832 13.8681 4.46096 13.8069 4.52213L12.4109 5.91845L12.4103 5.91911Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic_edit.b1cdb96e0db2dbb5e32a502add69e5f8.svg";
export { ForwardRef as ReactComponent };